import RegisterOption from "../../../components/marketplace/Signup";
import useMarketPlaceUserVerification from '../../../hooks/useMarketPlaceUserVerification'
import Header from "../../../components/marketplace/Header";
const MarketplaceHome = () => {
//   const {loading}=useMarketPlaceUserVerification()
//   if(loading) return (
//   <div className="flex items-center justify-center h-64">
//     <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//   </div>
// )
 return (
  <>
    <Header/>
    <RegisterOption />
  </>
);

};

export default MarketplaceHome;
